module.exports = __webpack_public_path__ + "media/images/step1-7b82ff5acebbc1db9e9cb20c03d68766.png";